export const PHONE_CONSENT_DISABLED_ENV = 'NEXT_PUBLIC_PHONE_CONSENT_DISABLED'

// Kill switch paired with RM_PHONE_CONSENT_ENABLED in Symfony — env var and not a GrowthBook flag, whose provider is only mounted on the routes listed in app/layout.tsx
export function isPhoneConsentModeEnabled(): boolean {
    return process.env.NEXT_PUBLIC_PHONE_CONSENT_DISABLED !== '1'
}

export function usePhoneConsentMode(): boolean {
    return isPhoneConsentModeEnabled()
}
